import React, {Component} from 'react'
import Webcam from "react-webcam";
import axios from "axios";
import Timer from "./Timer";


const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "user"
};


const API_KEY = "AIzaSyB-RnWak9ZMCT7u5mM834c1DjTa6TsYpb0";
const POST_URL = "https://vision.googleapis.com/v1/images:annotate?key=" + API_KEY;
let recognition = null;

class RecordAndShow extends Component {

    constructor(props) {
        super(props)
        this.state = {
            imagesCaptured: []
        }
    }


    componentDidMount() {
        this.lookForFrames()


        /*Voice to text*/

        try {
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            recognition = new SpeechRecognition();

            recognition.onresult = function (event) {

                // event is a SpeechRecognitionEvent object.
                // It holds all the lines we have captured so far.
                // We only need the current one.
                const current = event.resultIndex;

                // Get a transcript of what was said.
                const transcript = event.results[current][0].transcript;

                // Add the current transcript to the contents of our Note.
                console.log( transcript );
            };

            recognition.start()

        } catch (e) {
            console.error(e);

        }


    }

    setRef = webcam => {
        this.webcam = webcam;
    };

    capture = () => {

        const imageSrc = this.webcam.getScreenshot();
        // console.log(imageSrc)
        const {imagesCaptured} = this.state;
        if (imageSrc != null) {
            imagesCaptured.push(imageSrc)
            this.setState({imagesCaptured})
        }
    };


    lookForFrames() {
        console.log("looking for frames");
        const x = setInterval(() => {
            this.capture();
            console.log("Making request");

            this.makeRequest()
        }, 1000);

        setTimeout(() => {
            clearInterval(x)

            this.props.onFinishedVideo()

        }, 10000)
    }

    makeRequest() {

        //Get the frame
        let imageUrl = this.state.imagesCaptured.length > 0 ? this.state.imagesCaptured[this.state.imagesCaptured.length - 1] : "";
        imageUrl = imageUrl.replace('data:image/jpeg;base64,', '');

        if (imageUrl !== "") {


            axios.post(POST_URL,
                {
                    "requests": [
                        {
                            "image": {
                                "content": imageUrl
                            },
                            "features": [
                                {
                                    "type": "FACE_DETECTION",
                                    "maxResults": 1
                                }
                            ]
                        }
                    ]
                }
            ).then((response) => {
                this.processResponse(response)
            })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }

    processResponse(response) {
        this.setState({response});
        console.log(response);

    }


    render() {

        let eyeIcon = false;
        let smileIcon = false;
        let lightIcon = false;

        try {
            const {
                rollAngle, panAngle, tiltAngle, joyLIkelihood, sorrowLikelihood,
                angerLikelihood, surpriseLikelihood, underExposedLikelihood
            } = this.state.response.data.responses[0].faceAnnotations[0];


            console.log(panAngle, rollAngle, tiltAngle);


            if (Math.abs(panAngle) > 15) {
                // alert("Look at camera");
                eyeIcon = true;
            }

            if (sorrowLikelihood === "VERY_LIKELY" || angerLikelihood === "VERY_LIKELY" || surpriseLikelihood === "VERY_LIKELY" || joyLIkelihood === "VERY_UNLIKELY") {
                smileIcon = true;
            }

            if (underExposedLikelihood === "VERY_LIKELY") {
                lightIcon = true;
            }

        } catch (e) {
            console.log("Missed framelo")
        }

        eyeIcon = eyeIcon ? "red" : "green";
        smileIcon = smileIcon ? "red" : "green";
        lightIcon = lightIcon ? "red" : "green";

        return (

            <div className={"card-panel z-depth-0"}>

                <div className={"row"}>

                    <div className={"col s4 center"}>

                        <i className={"material-icons"} style={{color: eyeIcon}}>remove_red_eye</i>

                    </div>

                    <div className={"col s4  center"}>

                        <i className={"material-icons"} style={{color: smileIcon}}>tag_faces</i>

                    </div>

                    <div className={"col s4 center"}>

                        <i className={"material-icons"} style={{color: lightIcon}}>highlight</i>

                    </div>


                </div>

                <Webcam
                    style={{marginTop: "3%"}}
                    audio={true}
                    height={"auto"}
                    ref={this.setRef}
                    screenshotFormat="image/jpeg"
                    width={"100%"}
                    videoConstraints={videoConstraints}
                />

                <Timer time={10000} onFinished={() => {

                    recognition.stop();

                }}/>

            </div>
        )
    }


}

export default RecordAndShow;

